import React from "react";
import { NavLink } from "react-router-dom";

const NavImage = ({ item, icon, isSelected, setIsOpen, counter, onHide }) => {
  
  let count = counter;
  if (item.menu_children === undefined) count = 0;

  return (
    <span className={isSelected ? "divImg" : ""}>
          {/* <span className={isSelected !== true? "divImgnone" : "divImg"}> */}
       <NavLink
        to={item.menu_path}
        onClick={() => {
          if (item.menu_path === "#") {
            setIsOpen(true);
          }
          onHide(count);
        }}
        key={"A" + item.menu_id}
      >
        <img className="menu-icons" src={icon} alt=""></img>
      </NavLink>
    </span>
  );
};

export default NavImage;
